import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import ErrorBoundary from '../components/ErrorBoundary';
import MainPaymentAnalytics from '../components/MainPaymentAnalytics';
import { FiActivity, FiGlobe, FiDollarSign } from 'react-icons/fi';

const MainDashboard = () => {
    return (
        <Layout>
            <ErrorBoundary
                fallbackTitle="Main Dashboard Error"
                fallbackDescription="An error occurred while loading the main dashboard. Please try again or contact support if the problem persists."
            >
                <div className="space-y-6 w-full max-w-none px-8 py-6">
                    <div className="bg-white rounded-lg shadow p-6">
                        <h2 className="text-xl font-semibold mb-4">Main Dashboard</h2>
                        <p className="text-gray-600">
                            Combined payment analytics from all sources (SBF, Unblock, God, Superman, and more).
                            Use the filter dropdown to view specific categories or see all combined.
                        </p>
                        <Link
                            to="/main-dashboard/recent-deletes"
                            className="inline-flex items-center gap-2 mt-4 px-4 py-2 rounded-md text-sm font-medium text-amber-800 bg-amber-50 border border-amber-200 hover:bg-amber-100"
                        >
                            Recent Deletes (trash)
                        </Link>
                    </div>

                    <div className="bg-white rounded-lg shadow p-6">
                        <h2 className="text-xl font-semibold mb-2">Exchange Rates</h2>
                        <p className="text-gray-600 mb-4">
                            Daily Forex (SGD→fiat) and Crypto (SGD/USDT→coin) rates with charts.
                        </p>
                        <Link
                            to="/exchange-rates"
                            className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium text-emerald-800 bg-emerald-50 border border-emerald-200 hover:bg-emerald-100"
                        >
                            <FiDollarSign className="w-4 h-4" />
                            Open Exchange Rates
                        </Link>
                    </div>

                    <div className="bg-white rounded-lg shadow p-6">
                        <h2 className="text-xl font-semibold mb-2">Analytics</h2>
                        <p className="text-gray-600 mb-4">Website traffic and visitor reports.</p>
                        <div className="flex flex-wrap gap-3">
                            <Link
                                to="/analytics/slgweb"
                                className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium text-blue-700 bg-blue-50 border border-blue-200 hover:bg-blue-100"
                            >
                                <FiActivity className="w-4 h-4" />
                                SLGWeb Analytics
                            </Link>
                            <Link
                                to="/analytics/reviewweb"
                                className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium text-violet-700 bg-violet-50 border border-violet-200 hover:bg-violet-100"
                            >
                                <FiGlobe className="w-4 h-4" />
                                ReviewWeb Analytics
                            </Link>
                            <Link
                                to="/analytics/simon"
                                className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium text-cyan-800 bg-cyan-50 border border-cyan-200 hover:bg-cyan-100"
                            >
                                <FiActivity className="w-4 h-4" />
                                Simon Analytics
                            </Link>
                            <Link
                                to="/analytics"
                                className="inline-flex items-center gap-2 px-4 py-2 rounded-md text-sm font-medium text-gray-700 bg-gray-50 border border-gray-200 hover:bg-gray-100"
                            >
                                View all analytics
                            </Link>
                        </div>
                    </div>

                    <MainPaymentAnalytics />
                </div>
            </ErrorBoundary>
        </Layout>
    );
};

export default MainDashboard;
